// 에디터 미리보기(iframe) 주소. 실제 공개 페이지와 같은 화면이 보이도록 공개 페이지(Next)의 /preview 를 띄운다.
// (pickitem-client 의 /preview/:domainName 레거시 화면은 남겨 두지만 에디터에서는 쓰지 않음)
const PAGE_CLIENT_URL = process.env.REACT_APP_PAGE_CLIENT_URL || window.location.origin;

export function getPreviewUrl(domainName, lcId) {
    const url = `${PAGE_CLIENT_URL}/preview/${domainName}`;
    return lcId ? `${url}?lcId=${lcId}` : url;
}
